/* bb-cart-filters.js — Bara Bros F2 Filter Chips
   Visual-only: hides/shows rows for browsing.
   Does NOT touch Select-B state, checkboxes, localStorage, or checkout logic. */
(function () {
  'use strict';

  var BAR_ID     = 'bb-filters-bar';
  var EMPTY_ID   = 'bb-filter-empty';
  var HIDDEN_CLS = 'bb-filter-hidden';
  var activeChip = 'all';
  var reinjTimer = null;

  var LEGACY_CHIPS = [
    { id: 'all',   label: 'All' },
    { id: 'flash', label: 'Flash Sale' },
    { id: 'mark',  label: 'Markdowns' },
    { id: 'low',   label: 'Low Stock' },
    { id: 'aso',   label: 'Almost Sold Out' }
  ];

  /* Liquid Glow: only filters backed by cart data. "On sale" is the row's
     data-bb-on-sale (compare-at markdown or an allocated line discount).
     Counts are units, like every other count in the cart. No "Saved" tab:
     saved items live in the wishlist, not in the cart. */
  var GLOW_CHIPS = [
    { id: 'all',  label: 'All' },
    { id: 'sale', label: 'On sale' }
  ];

  var CHIPS = LEGACY_CHIPS;

  function isGlow() {
    return !!document.querySelector('cart-items-component.bb-glow');
  }

  // ── DOM helpers ──────────────────────────────────────────────────────────────

  function getRows() {
    // Mirrors bb-cart-selection.js getRows() — all rows regardless of visibility
    return Array.from(document.querySelectorAll('[data-bb-line-key]'));
  }

  function getTable() {
    var tbody = document.getElementById('main-cart-items');
    if (!tbody) return null;
    // #main-cart-items is the wrapper <div> around the table, so closest()
    // never finds it and the legacy chips have never rendered. Liquid Glow
    // looks inside; the legacy lookup is left as it was so the tag-based
    // legacy chips don't appear unannounced.
    return isGlow() ? tbody.querySelector('table.cart-items__table') : tbody.closest('table');
  }

  // ── Markdown keys — read from JSON data block injected by cart-total.liquid ──

  function getMarkdownKeys() {
    var result = {};
    try {
      var el = document.getElementById('bb-cart-items-data');
      if (!el) return result;
      JSON.parse(el.textContent || '[]').forEach(function (item) {
        if (item.cad > 0) result[item.key] = true;
      });
    } catch (_) {}
    return result;
  }

  // ── Per-chip match logic ──────────────────────────────────────────────────────

  function rowMatches(row, chipId, markdownKeys) {
    switch (chipId) {
      case 'all':   return true;
      case 'sale':  return row.dataset.bbOnSale === 'true';
      case 'flash': return row.dataset.bbShowFlashImg === 'true';
      case 'mark':  return !!markdownKeys[row.dataset.bbLineKey];
      case 'low':   return row.dataset.bbHasLow === 'true';
      case 'aso':   return row.dataset.bbHasAso === 'true';
    }
    return true;
  }

  // ── Count rows matching each chip ─────────────────────────────────────────────

  function computeCounts(rows, markdownKeys) {
    var c = { all: 0, sale: 0, flash: 0, mark: 0, low: 0, aso: 0 };
    rows.forEach(function (row) {
      var units = parseInt(row.dataset.bbLineQuantity || '1', 10) || 1;
      c.all += units;
      if (row.dataset.bbOnSale === 'true')       c.sale += units;
      if (row.dataset.bbShowFlashImg === 'true') c.flash++;
      if (markdownKeys[row.dataset.bbLineKey])   c.mark++;
      if (row.dataset.bbHasLow === 'true')       c.low++;
      if (row.dataset.bbHasAso === 'true')       c.aso++;
    });
    return c;
  }

  // ── Apply filter: toggle HIDDEN_CLS on rows and refresh chip + empty state ───

  function applyFilter(chipId) {
    activeChip = chipId;
    var rows = getRows();
    var markdownKeys = getMarkdownKeys();
    var visible = 0;

    rows.forEach(function (row) {
      var match = rowMatches(row, chipId, markdownKeys);
      row.classList.toggle(HIDDEN_CLS, !match);
      if (match) visible++;
    });

    // Sync chip active + aria-pressed state
    var bar = document.getElementById(BAR_ID);
    if (bar) {
      bar.querySelectorAll('.bb-filter-chip').forEach(function (btn) {
        var on = btn.dataset.chipId === chipId;
        btn.classList.toggle('bb-filter-chip--active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    // Empty state message
    var emptyEl = document.getElementById(EMPTY_ID);
    if (emptyEl) {
      if (chipId !== 'all' && visible === 0) {
        var chip = CHIPS.filter(function (c) { return c.id === chipId; })[0];
        emptyEl.textContent = chipId === 'sale'
          ? 'Nothing in your cart is on sale right now. Your cart is unchanged.'
          : 'No ' + (chip ? chip.label : chipId) + ' items in your cart.';
        emptyEl.style.display = 'block';
      } else {
        emptyEl.style.display = 'none';
      }
    }
  }

  // ── Build chip bar element ─────────────────────────────────────────────────────

  function buildBar(counts) {
    var bar = document.createElement('div');
    bar.id = BAR_ID;
    bar.className = 'bb-filters-bar';
    bar.setAttribute('role', 'toolbar');
    bar.setAttribute('aria-label', 'Filter cart items');

    CHIPS.forEach(function (chip) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.dataset.chipId = chip.id;

      var isEmpty = chip.id !== 'all' && counts[chip.id] === 0;
      var isActive = chip.id === activeChip;

      btn.className = 'bb-filter-chip' +
        (isActive ? ' bb-filter-chip--active' : '') +
        (isEmpty  ? ' bb-filter-chip--empty'  : '');
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      if (isEmpty) btn.setAttribute('aria-disabled', 'true');
      if (isGlow()) {
        // "All (3)" / "On sale (1)" — units, with the unit word for screen readers.
        var n = counts[chip.id];
        btn.innerHTML = chip.label + ' (' + n +
          '<span class="visually-hidden"> ' + (n === 1 ? 'item' : 'items') + '</span>)';
      } else {
        btn.textContent = chip.id === 'all'
          ? chip.label
          : chip.label + ' (' + counts[chip.id] + ')';
      }

      btn.addEventListener('click', function () {
        if (btn.getAttribute('aria-disabled') === 'true') return;
        applyFilter(chip.id);
      });
      bar.appendChild(btn);
    });

    return bar;
  }

  // ── Inject bar and empty placeholder above the items table ───────────────────

  function setupChips() {
    if (!document.getElementById('main-cart-items')) return; // empty cart or not cart page
    if (document.getElementById(BAR_ID)) return;             // double-injection guard

    var table = getTable();
    if (!table) return;

    CHIPS = isGlow() ? GLOW_CHIPS : LEGACY_CHIPS;
    if (!CHIPS.some(function (c) { return c.id === activeChip; })) activeChip = 'all';

    var rows = getRows();
    var markdownKeys = getMarkdownKeys();
    var counts = computeCounts(rows, markdownKeys);

    // An active filter that no longer matches anything falls back to All.
    if (activeChip !== 'all' && !counts[activeChip]) activeChip = 'all';

    var bar = buildBar(counts);
    var slot = document.querySelector('[data-bb-filters-slot]');
    if (slot) slot.appendChild(bar);
    else table.parentNode.insertBefore(bar, table);

    var emptyEl = document.createElement('div');
    emptyEl.id = EMPTY_ID;
    emptyEl.className = 'bb-filter-empty-state';
    emptyEl.setAttribute('aria-live', 'polite');
    emptyEl.setAttribute('role', 'status');
    emptyEl.style.display = 'none';
    table.parentNode.insertBefore(emptyEl, table);

    applyFilter(activeChip);
  }

  // ── Bootstrap ─────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupChips);
  } else {
    setupChips();
  }

  // Re-inject after every AJAX cart re-render; debounced to handle rapid events
  document.addEventListener('cart:updated', function () {
    clearTimeout(reinjTimer);
    reinjTimer = setTimeout(setupChips, 120);
  });

})();
